import { GetterTree } from "vuex/types"

import { RootState } from "~/store/store.types"
import get from '~/helpers/get'
import Theme from "~/constants/theme"

import { JssState } from "./types"

const getters: GetterTree<JssState, RootState> = {
  isEditMode ({ context }) {
    return context && context.pageEditing
  },

  isPreviewMode ({ context }) {
    return context && context.pageState === 'preview'
  },

  isExperiencedMode(_, { isEditMode, isPreviewMode }) {
    return isEditMode || isPreviewMode
  },

  colorTheme ({ route }, { isEditMode }) {
    if (isEditMode) {
      return Theme.White
    }

    return get(route, 'fields.colorTheme.value', Theme.White)
  }
}

export default getters
